(function () {
  const STORAGE_KEY = "utm_tracking";

  function saveTrafficSource() {
    try {
      const hasUTM = window.location.search.includes("utm_");
      const pathAndQuery = window.location.pathname + window.location.search;

      if (hasUTM) {
        localStorage.setItem(STORAGE_KEY, pathAndQuery);
        updateCartAttributes(pathAndQuery);
      }
    } catch (error) {
      console.error("Error saving traffic source:", error);
    }
  }

  function checkAndUpdateCartAttributes() {
    return fetch("/cart.js")
      .then((response) => {
        if (!response.ok) throw new Error("Failed to fetch cart");
        return response.json();
      })
      .then((cart) => {
        if (!cart.attributes || !cart.attributes.utm_tracking) {
          const storedUTM = localStorage.getItem(STORAGE_KEY);
          if (storedUTM) {
            return updateCartAttributes(storedUTM);
          }
        }
      })
      .catch((error) => {
        return Promise.resolve();
      });
  }

  function updateCartAttributes(pathAndQuery) {
    const cartUpdateData = {
      attributes: {
        utm_tracking: pathAndQuery,
      },
    };

    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cartUpdateData),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Failed to update cart attributes");
        return response.json();
      })
      .then((data) => {
        console.log("Cart attributes updated successfully:", data.attributes);
      })
      .catch((error) => {
        console.error("Error updating cart attributes:", error);
      });
  }

  function handleCheckoutButtonClick() {
    document.addEventListener("submit", (event) => {
      const form = event.target;
      if (form.matches("form[action='/checkout']")) {
        event.preventDefault();

        checkAndUpdateCartAttributes()
          .then(() => {
            form.submit();
          })
          .catch(() => {
            console.error("Error occurred, but proceeding to checkout...");
            form.submit();
          });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    saveTrafficSource();
    handleCheckoutButtonClick();
  });
})();
